export default "__VITE_ASSET__CItVNazQ__"